import React, { useState } from 'react';
import PmsRoomTypeMaster from './PmsRoomTypeMaster';
import PmsRoomMaster from './PmsRoomMaster';
import PmsRoomInventorySetup from './PmsRoomInventorySetup';
import PmsRatePlanMaster from './PmsRatePlanMaster';
import PmsCorporateMaster from './PmsCorporateMaster';
import PmsTravelAgentMaster from './PmsTravelAgentMaster';
import PmsSalesTeamMaster from './PmsSalesTeamMaster';

import PmsCancellationPolicies from './PmsCancellationPolicies';
import PmsServiceMaster from './PmsServiceMaster';
import PmsGuestServiceMaster from './PmsGuestServiceMaster';
import PmsReceiptSettings from './PmsReceiptSettings';
import PmsReceiptHistory from './PmsReceiptHistory';
import PmsBillingInfoMaster from './PmsBillingInfoMaster';
import PmsLocalEventCalendar from './PmsLocalEventCalendar';

function PmsMastersHub({ token, selectedProperty }) {
  const [tab, setTab] = useState('room-type');
  const tabBtn = (active) => ({
    padding: '0.55rem 0.85rem',
    borderRadius: '7px',
    border: '1px solid #cbd5e0',
    background: active ? 'var(--theme-primary)' : '#fff',
    color: active ? '#fff' : '#1f2937',
    cursor: 'pointer'
  });

  return (
    <div style={{ padding: '1rem' }}>
      <h2 style={{ marginTop: 0, color: 'var(--theme-primary)' }}>Front Office - Masters</h2>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.7rem', flexWrap: 'wrap' }}>
        <button onClick={() => setTab('room-type')} style={tabBtn(tab === 'room-type')}>Room Type</button>
        <button onClick={() => setTab('rate-plan')} style={tabBtn(tab === 'rate-plan')}>Rate Plan</button>
        <button onClick={() => setTab('room-inventory')} style={tabBtn(tab === 'room-inventory')}>Room Config</button>
        <button onClick={() => setTab('room')} style={tabBtn(tab === 'room')}>Room</button>
        <button onClick={() => setTab('corporate')} style={tabBtn(tab === 'corporate')}>Corporate</button>
        <button onClick={() => setTab('travel-agent')} style={tabBtn(tab === 'travel-agent')}>Travel Agent</button>
        <button onClick={() => setTab('sales-team')} style={tabBtn(tab === 'sales-team')}>Sales Team</button>
        <button onClick={() => setTab('billing-info')} style={tabBtn(tab === 'billing-info')}>Billing Info</button>
        <button onClick={() => setTab('service-master')} style={tabBtn(tab === 'service-master')}>Service Master</button>
        <button onClick={() => setTab('guest-service-master')} style={tabBtn(tab === 'guest-service-master')}>Guest Service Master</button>
        <button onClick={() => setTab('receipt-settings')} style={tabBtn(tab === 'receipt-settings')}>Receipt Settings</button>
        <button onClick={() => setTab('receipt-history')} style={tabBtn(tab === 'receipt-history')}>Receipt History</button>

        <button onClick={() => setTab('cancellation-policy')} style={tabBtn(tab === 'cancellation-policy')}>Cancellation Policies</button>
        <button onClick={() => setTab('local-events')} style={tabBtn(tab === 'local-events')}>Local Event Calendar</button>
      </div>
      <div className="card">
        {tab === 'room-type' ? <PmsRoomTypeMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'rate-plan' ? <PmsRatePlanMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'room-inventory' ? <PmsRoomInventorySetup token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'room' ? <PmsRoomMaster token={token} selectedProperty={selectedProperty} onNavigateToTab={setTab} /> : null}
        {tab === 'corporate' ? <PmsCorporateMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'travel-agent' ? <PmsTravelAgentMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'sales-team' ? <PmsSalesTeamMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'billing-info' ? <PmsBillingInfoMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'service-master' ? <PmsServiceMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'guest-service-master' ? <PmsGuestServiceMaster token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'receipt-settings' ? <PmsReceiptSettings token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'receipt-history' ? <PmsReceiptHistory token={token} selectedProperty={selectedProperty} /> : null}

        {tab === 'cancellation-policy' ? <PmsCancellationPolicies token={token} selectedProperty={selectedProperty} /> : null}
        {tab === 'local-events' ? <PmsLocalEventCalendar token={token} selectedProperty={selectedProperty} /> : null}
      </div>
    </div>
  );
}

export default PmsMastersHub;
